import { gql, useLazyQuery } from "@apollo/client";
import { GoodStatus, ListCorporationSelectQuery } from "../gql/graphql";
import {
  CouponScope,
  CouponStatus,
  UserCouponStatus,
} from "../constants/props";

const LIST_COUPON_LOCATION = gql`
  query listCouponLocation($input: ListCouponLocationInput!) {
    listCouponLocation(input: $input) {
      ok
      err
      coupons {
        isAvailable
        userCouponId
        userCouponStatus
        unavailableReason
        coupon {
          id
          name
          scope
          status
          validFrom
          validUntil
          discountPrice
          description
          code
          linkService {
            id
            name
          }
          corporation {
            id
            name
          }
        }
      }
    }
  }
`;

export interface ListCouponLocationInput {
  input: {
    serviceId: number;
    userId?: number;
  };
}

export interface ListCouponLocationQuery {
  listCouponLocation: {
    ok: boolean;
    err: string;
    coupons: {
      id: string;
      isAvailable: boolean;
      userCouponId?: number;
      userCouponStatus?: UserCouponStatus;
      unavailableReason?: string;
      coupon: {
        id: string;
        name: string;
        scope: CouponScope;
        status: CouponStatus;
        validFrom: string;
        validUntil: string;
        discountPrice: number;
        description: string;
        code: string;
        linkService: {
          id: number;
          name: string;
        };
        corporation: {
          id: number;
          name: string;
        };
      };
    }[];
  };
}

export const useListCouponLocation = (
  onCompleted?: (data: ListCouponLocationQuery) => void
) => {
  return useLazyQuery<ListCouponLocationQuery>(LIST_COUPON_LOCATION, {
    onCompleted,
    fetchPolicy: "network-only",
  });
};
